<!-- ========================== intro (start) ========================== -->

<main class="l-deashboard summary" [formGroup]="summaryForm">
  <ng-container
    *ngIf="es.ExamType != 'Consultation Letter' && es.ExamType !== 'Pulmonary functional assessment' && es.ExamType !== 'Methacholine test'"
  >
    <div
      class="h100 t-boxMargin"
      style="padding-right: 0.87em; padding-left: 0.87em; position: relative"
      *ngIf="es.ExamType !== 'Stress' && es.ExamType !== 'Holter ECG' && es.ExamType != 'Duplex Carotid'"
    >
      <div
        class="l-flex-c l-flex-w"
        style="position: relative; bottom: -1em; right: 3em; float: right; width: fit-content"
        *ngIf="es.ExamType != 'Duplex Carotid'"
      >
        <label class="t-label-top">
          <span> Measured LVEF </span>
          <span class="t-field t-field--number">
            <input class="t-field-text" type="number" min="0" formControlName="LVEFmeas" />
          </span>
        </label>
        <label class="t-label-top">
          <span> Estimated LVEF </span>
          <select class="t-select t-field" formControlName="LVEF">
            <option default [ngValue]="null"></option>
            <option value="&#62; 70">&#62; 70</option>
            <option value="55-70">55-70</option>
            <option value="50-54">50-54</option>
            <option value="45-49">45-49</option>
            <option value="40-44">40-44</option>
            <option value="35-39">35-39</option>
            <option value="30-34">30-34</option>
            <option value="25-29">25-29</option>
            <option value="20-24">20-24</option>
            <option value="15-19">15-19</option>
            <option value="15 &#60;">15 &#60;</option>
            <option value="Unable to estimate EF">Unable to estimate EF</option>
          </select>
        </label>
        <button
          class="t-btn-edit"
          *ngIf="!es.isClosed"
          (click)="
            atS.showAuto(
              summaryForm.get('LVEF'),
              'Estimated LVEF',
              es.ExamType == 'TTE Adults'
                ? 63
                : es.ExamType == 'Stress-Echo'
                ? 62
                : es.ExamType == 'TTE Pediatric'
                ? 2015
                : 64
            )
          "
          style="right: -3em; top: -2em"
        >
          Auto Text
        </button>
        <button
          class="t-btn-edit"
          *ngIf="!es.isClosed && lastFindings"
          (click)="addLastFindings()"
          style="margin-right: 4em; top: -2em"
        >
          Load pre Findings
        </button>
      </div>
      <!-- row (end) -->

      <!-- cell : recommendations -->
      <app-diagnoses
        group="summary"
        [form]="summaryForm.get('DiagnosisCodes')"
        [text]="summaryForm.get('Anomalies')"
        [textStress]="summaryForm.get('AnomaliesStress')"
        class="w100 summary-boxHeight summary-extradocs"
        autoid="51"
        autoidstress="407"
        [textonly]="true"
      >
      </app-diagnoses>
    </div>
    <!-- row : Summary in Stress exam -->

    <div
      class="h100 t-boxMargin"
      *ngIf="es.ExamType == 'Duplex Carotid'"
      style="padding-right: 0.87em; padding-left: 0.87em; position: relative"
    >
      <app-cardio-flow-meas></app-cardio-flow-meas>
    </div>
    <div
      class="h100 l-flex-w t-boxMargin--spacebyPadding"
      *ngIf="es.ExamType === 'Stress' || es.ExamType === 'Holter ECG'"
    >
      <div class="w50 summary-boxHeight summary-indicative" style="height: 10em">
        <section class="m-box" style="height: 100%">
          <h2>Functional Assessments</h2>
          <textarea class="scroller" formControlName="Assessments"></textarea>
          <button
            class="t-btn-edit"
            *ngIf="!es.isClosed"
            (click)="
              atS.showAuto(
                summaryForm.get('Assessments'),
                'Functional Assessments',
                es.ExamType === 'Stress' ? 512 : 2512
              )
            "
          >
            Auto Text
          </button>
        </section>
      </div>
      <div class="w50 summary-boxHeight summary-indicative" style="height: 10em">
        <section class="m-box" style="height: 100%">
          <h2>Summary</h2>
          <textarea class="scroller" formControlName="Summary"></textarea>
          <button
            class="t-btn-edit"
            *ngIf="!es.isClosed"
            (click)="
              atS.showAuto(summaryForm.get('Summary'), 'Summary', es.ExamType === 'Stress' ? 511 : 2511)
            "
          >
            Auto Text
          </button>
        </section>
      </div>
    </div>
    <!-- endrow : Summary in Stress exam -->

    <div class="h100 l-flex-w t-boxMargin--spacebyPadding" style="margin-top: 2em; height: auto">
      <div class="w50">
        <section class="m-box">
          <h2>Diagnosis</h2>

          <app-dx-search [control]="summaryForm.get('Diagnosis')"></app-dx-search>
          <textarea class="scroller" formControlName="Diagnosis" style="height: 8em"></textarea>
          <button
            class="t-btn-edit"
            *ngIf="!es.isClosed && lastDiagnosis"
            (click)="addLastDiagnosis()"
            style="margin-right: 6em"
          >
            Previous Diagnosis
          </button>
          <button
            class="t-btn-edit"
            *ngIf="!es.isClosed"
            (click)="
              atS.showAuto(
                summaryForm.get('Diagnosis'),
                'Diagnosis',
                es.ExamType === 'TTE Adults'
                  ? 43
                  : es.ExamType === 'Stress-Echo'
                  ? 42
                  : es.ExamType === 'Holter ECG'
                  ? 2044
                  : es.ExamType === 'TTE Pediatric'
                  ? 2013
                  : 44
              )
            "
          >
            Auto Text
          </button>

          <div class="sep-8"></div>

          <div>
            <div style="display: flex; justify-content: space-between; align-items: center">
              <h2
                style="margin-bottom: 16px; font-size: inherit; font-weight: 400; background: transparent"
              >
                Diagnosis Comments
              </h2>
              <button
                class="t-btn-edit"
                *ngIf="!es.isClosed"
                style="position: static"
                (click)="atS.showAuto(summaryForm.get('Conclusions'), 'Diagnosis Comments', 408)"
              >
                Auto Text
              </button>
            </div>
            <textarea class="scroller" formControlName="Conclusions" style="height: 5em"></textarea>
          </div>
        </section>
      </div>

      <div class="w50 summary-boxHeight summary-indicative">
        <section class="m-box" style="height: 100%">
          <h2>Recommendations</h2>
          <textarea class="scroller" formControlName="Recomm"></textarea>
          <button
            class="t-btn-edit"
            *ngIf="!es.isClosed && lastRecommendations"
            (click)="addLastRecomm()"
            style="margin-right: 6em"
          >
            Previous Recommendations
          </button>
          <button
            class="t-btn-edit"
            *ngIf="!es.isClosed"
            (click)="
              atS.showAuto(
                summaryForm.get('Recomm'),
                'Recommendations',
                es.ExamType == 'TTE Adults'
                  ? 53
                  : es.ExamType == 'Stress-Echo'
                  ? 52
                  : es.ExamType === 'Holter ECG'
                  ? 2054
                  : es.ExamType === 'TTE Pediatric'
                  ? 2014
                  : 54
              )
            "
          >
            Auto Text
          </button>
        </section>
      </div>

      <!-- cell : indicative way of examination -->

      <div
        class="w50 summary-boxHeight summary-indicative"
        *ngIf="!ls.ishospital && summaryForm.get('HMO').value == 'Leumit' && ls.hasLeumit"
      >
        <section class="m-box">
          <h2>PRN & Treatment Code</h2>
          <div class="l-flex-c l-flex-w indicative-fieldset h100">
            <label class="t-label-top">
              <span> Payer Reference Num </span>
              <span class="t-field t-field--number">
                <input
                  class="t-field-text"
                  type="number"
                  formControlName="PRN"
                  (keyup)="checklength()"
                  [ngClass]="prnerr ? 'is-invalid' : ''"
                />
                <div class="t-validation-message">
                  <span>{{ prnerr }}</span>
                </div>
              </span>
            </label>

            <label class="t-label-top">
              <span> Code of Treatment </span>
              <span class="t-field t-field--number">
                <input
                  class="t-field-text"
                  type="number"
                  formControlName="TreatmentCode"
                  [ngClass]="trerr ? 'is-invalid' : ''"
                  (keyup)="checklength()"
                />
                <div class="t-validation-message">
                  <span>Invalid Treament Code</span>
                </div>
              </span>
            </label>

            <button class="save_patieont" (click)="checkPRN()" *ngIf="ls.PRNcheck && checkleumit">
              Check Validity
            </button>
            <div *ngIf="ls.PRNcheck && checkleumit" style="margin-left: auto">
              Invalid PRNs will not be saved
            </div>
          </div>
        </section>
      </div>
      <!-- cell : Summary -->

      <!-- endcell : Summary -->
    </div>
  </ng-container>

  <!-- =============== Exam Signature (Start) =============== -->
  <div
    class="h100 l-flex-w t-boxMargin--spacebyPadding"
    style="padding-bottom: 1em; place-content: center"
  >
    <div [ngClass]="es.ExamType != 'Stress-Echo' ? 'signexam' : 'w50'">
      <div
        class="m-box"
        [ngClass]="es.ExamType != 'Stress-Echo' ? 'w50' : ''"
        *ngIf="ls.userType == 'doctor'"
      >
        <h2>Sign Exam</h2>

        <div class="l-flex-c l-flex-w indicative-fieldset h100">
          <button class="save_patieont" *ngIf="showSign()" (click)="showPrintOpts = true">
            Sign Exam as {{ ls.getUserName() }}
          </button>

          <span *ngIf="signed && oldSignature">
            Signed on {{ signed | date : "d-M-y H:mm:ss" }} by {{ signer }}
          </span>
          <span *ngIf="signatureService.isExamSigned(es.examObject) ">
            Signed on {{ es.examObject.SignedDate | date : "d-M-y H:mm:ss" }} by
            {{ es.examObject.SignedBy }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <!-- =============== Exam Signature (End) =============== -->
</main>

<app-printopts
  *ngIf="showPrintOpts"
  (closed)="closePreview($event)"
  [showopts]="false"
  [signature]="true"
></app-printopts>
